// extracted by mini-css-extract-plugin
module.exports = {"remainingBudgetCellActive":"Budget_remainingBudgetCellActive__3JgQP","bugdetChange":"Budget_bugdetChange__1VinT"};